<div class="right-panel h-100 text-grey">
  <div class="main">
    <div class="actionBar">
      <input type="text"
             placeholder="Search by Name, Status, Location..."
             [(ngModel)]="searchTerm"
             (input)="onSearch()"
             class="search" />


      <button type="button"
              class="actionBtn ms-1"
              *ngIf="checkIfOnPremiseDeployment()"
              (click)="checkDepStatus()"
              ngbTooltip="Check Deployment Status"
              (mousedown)="statustooltip.close()"
              (mouseenter)="statustooltip.open()"
              (mouseleave)="statustooltip.close()"
              triggers="manual"
              #statustooltip="ngbTooltip">
        <i class="fa bi-chat-left-text"></i>
      </button>
      <button type="button"
              class="actionBtn ms-1"
              (click)="openLink('logs')"
              ngbTooltip="Deployment Logs"
              (mousedown)="logstooltip.close()"
              (mouseenter)="logstooltip.open()"
              (mouseleave)="logstooltip.close()"
              triggers="manual"
              #logstooltip="ngbTooltip">
        <i class="bi bi-body-text"></i>
      </button>
      <button class="actionBtn"
              *ngIf="isUserGlobalAdmin"
              (click)="deleteDeployment()"
              ngbTooltip="Delete Deployment"
              (mousedown)="deletetooltip.close()"
              (mouseenter)="deletetooltip.open()"
              (mouseleave)="deletetooltip.close()"
              triggers="manual"
              #deletetooltip="ngbTooltip">
        <i class="bi bi-trash"></i>
      </button>


      <button type="button" class="actionBtn" (click)='refreshComponent()' triggers="hover" ngbTooltip="Refresh Details">
        <span class="bi bi-arrow-clockwise"></span>

      </button>

      <button type="button" *ngIf="this.isOnPremise"
              class="actionBtn"
              (click)="powerOnGracefully()"
              triggers="hover" ngbTooltip="Power on all the nodes and runs custom scripts">
        <span class="bi bi-plug">
        </span>
      </button>
      <button type="button" *ngIf="this.isOnPremise"
              class="actionBtn"
              (click)="powerOffGracefully()"
              triggers="hover" ngbTooltip="Graceful power off">
        <span class="bi bi-power">

        </span>
      </button>

      <button type="button"
              class="actionBtn"
              (click)="openLink('Settings')"
              triggers="hover" ngbTooltip="Settings">
        <span class="bi bi-gear">

        </span>
      </button>

    </div>

    <div class="wrapper">
      <mat-card class="mat-elevation-z2 main-card">
        <mat-card-content class="px-2" >
        
        <section class="quick-stats">
        <h3>Quick Stats :</h3>
        <div class="summary-grid">
          <div class="summary-item"
            *ngFor="let detail of filteredDeploymentDetails(true); let i = index; let last = last"  
          >
            <span class="label">{{ detail.title }} <span class="fw-bold">:</span>
              <i 
                *ngIf="detail.link == true"
                class="bi bi-box-arrow-up-right" 
                style="color: var(--s-primary-color); margin-left: .5rem; cursor: pointer"
                (click)="openLink(detail.title)" 
                [class.disableLink]="detail.title.toLowerCase().indexOf('storage') != -1 && !storage"></i>
            </span>
            <span class="value">{{ detail.value }}</span>
          </div>
        </div>
      </section>
      
      <mat-divider class="my-3"></mat-divider>
      
      <section class="additional-info">
        <h3>Additional Info :</h3>
        <div class="summary-grid">
          <div class="summary-item"
            *ngFor="let detail of filteredDeploymentDetails(false); let i = index; let last = last"  
            >
                <span class="label">{{ detail.title }} :</span>
                <span class="value">{{ detail.value }}</span>
              </div>
            </div>
          </section>
        </mat-card-content>
      </mat-card>
  
      <div *ngIf="showGCPPartitionTable == true">
        <div class="actionBar">
          <div class="pagination-container float-end">
            <div style="display:flex; justify-content:space-between; align-items:center">
              <button class="default-btn"
                      style="border: 1px solid"
                      (click)="addNewPartition()">
                <span>
                  <i class="bi bi-plus"></i>
                  New Node Group
                </span>
              </button>
            </div>
          </div>
        </div>
  
        <div class="listTable flex-grow-1" style="white-space: nowrap; overflow-y: auto; height: 35vh;">
          <div class="x">
            <table class="table table-hover"
                   cellspacing="0"
                   style="border-collapse: collapse"
                   *ngIf="partitionsAvailable">
              <thead style="text-align: center">
                <tr class="table-list-head" style="color: White; background-color: var(--s-primary-color); height: 22px">
                  <th scope="col" resizable>
                    <a style="color: White; text-decoration: none; cursor: default">#</a>
                  </th>
                  <th scope="col" resizable>
                    <a style="color: White; text-decoration: none; cursor: default">Name</a>
                  </th>
                  <th scope="col" resizable>Instance Type</th>
                  <th scope="col" resizable>Dynamic Node Count</th>
                  <th scope="col" resizable>Static Node Count</th>
                  <th scope="col" resizable>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-list-row" *ngFor="let partition of filteredPartitions() ; let i = index" style="text-align:center">
                  <td>{{ i + 1 }}</td>
                  <td #partNameCell class="impListName">{{ partition.partitionName | shortenString :  200 }}</td>
                  <td title="{{ partition.instanceType }}">{{ partition.instanceType }}</td>
                  <td title="{{ partition.dynamicNodeCount }}">{{ partition.dynamicNodeCount }}</td>
                  <td title="{{ partition.staticNodeCount }}">{{ partition.staticNodeCount }}</td>
                  <td class="controlActions">
                    <span class="bi bi-pencil-square" title="Update Node Group" (click)="updatePartition(partition)"></span>
                    <span class="bi bi-trash text-danger" title="Delete Node Group" (click)="deletePartition(partition)"></span>
                  </td>
                </tr>
              </tbody>
            </table>
  
            <p id="emptyError" *ngIf="partitionsAvailable == false">
              No Node Groups are available for selected deployment
            </p>
          </div>
        </div>
      </div>
  
      <div *ngIf="showPartitionDetails == true">
        <div class="actionBar">
          <div class="pagination-container float-end">

            <div ngbDropdown container="body" class="newDir" *ngIf="showOnlyPartitionCreateButton == false">
              <button class="default-btn" container="body" placement="left" ngbTooltip="New Node Group" ngbDropdownToggle
                      style="border: 1px solid var(--s-primary-color); float: left">
                      <!-- *ngIf="isMonitor == false"> -->
                <span class="bi bi-plus-lg">Node Group</span>
              </button>
              <div ngbDropdownMenu style="padding: 0.5rem">
                <button ngbDropdownItem
                        class="default-btn"
                        style="border: 1px solid var(--s-primary-color); float: left"
                        (click)="addNewPartition()"
                        title="Create slurm node group (partition)">
                        <!-- *ngIf="isMonitor == false"> -->
                  <span class="bi bi-plus-lg"></span> Create Slurm Node Group (Partition)
                </button>
                <button ngbDropdownItem
                        class="default-btn"
                        style="border: 1px solid var(--s-primary-color); float: left; margin-top: 2%"
                        (click)="addNewPartition(false)"
                        title="Create node group (partition) along with nodes">
                        <!-- *ngIf="isMonitor == false"> -->
                  <span class="bi bi-plus-lg"></span> Create Node Group (Partition) Along With Nodes
                </button>
              </div>
            </div>
            <div *ngIf="showOnlyPartitionCreateButton == true">
              <button 
                        class="default-btn"
                        style="border: 1px solid var(--s-primary-color); float: left"
                        (click)="addNewPartition()"
                        title="Create node group">
                  <span class="bi bi-plus-lg"></span> Create Node Group
                </button>
            </div>
          </div>
        </div>
  
        <div class="listTable flex-grow-1" style="white-space: nowrap; overflow-y: auto; height: 35vh;">
          <div class="x">
            <table class="table table-hover"
                   cellspacing="0"
                   style="border-collapse: collapse"
                   *ngIf="partitionsAvailable">
              <thead style="text-align: center">
                <tr style="color: White; background-color: var(--s-primary-color); height: 22px">
                  <th scope="col" resizable>
                    <a style="color: White; text-decoration: none; cursor: default">#</a>
                  </th>
                  <th scope="col" resizable>
                    <a style="color: White; text-decoration: none; cursor: default">Name</a>
                  </th>
                  <th scope="col" resizable>Node Count</th>
                  <th scope="col" resizable>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let partition of filteredPartitions() ; let i = index" style="text-align:center">
                  <td>{{ i + 1 }}</td>
                  <td #partitionCell class="impListName">{{ partition.partitionName | shortenString : 200 }}</td>
                  <td title="{{ partition.staticNodeCount }}">{{ partition.staticNodeCount }}</td>
                  <td>
                    <div ngbDropdown container="body" class="newDir" style="align-items: center; justify-content: center;">
                      <button class="simple-btn" container="body" placement="left" ngbTooltip="Update Node Group" ngbDropdownToggle>
                        <span class="bi bi-pencil-square text-primary"></span>
                      </button>
                      <div ngbDropdownMenu style="padding: 0.5rem" *ngIf="showOnlyPartitionCreateButton == false">
                        <button ngbDropdownItem
                                class="default-btn"
                                (click)="updatePartition(partition)"
                                title="Update slurm node group (partition)">
                          <span class="bi bi-pencil-square"></span> Update Slurm Node Group (Partition)
                        </button>
                        <button ngbDropdownItem
                                class="default-btn"
                                style="margin-top: 5px;"
                                (click)="updatePartition(partition, false)"
                                title="Update node group (partition) along with nodes">
                          <span class="bi bi-pencil-square"></span> Update Node Group (Partition) Along With Nodes
                        </button>
                      </div>
                      <div ngbDropdownMenu style="padding: 0.5rem" *ngIf="showOnlyPartitionCreateButton == true">
                        <button 
                                class="default-btn"
                                (click)="updatePartition(partition)"
                                title="Update node group (partition)">
                          <span class="bi bi-pencil-square"></span> Update Node Group (Partition)
                        </button>
                      </div>
                      <span style="cursor: pointer;" class="bi bi-trash text-danger" title="Delete Node Group" (click)="deletePartition(partition)"></span>
                    </div>
                    <!-- <span class="bi bi-pencil-square" title="Update Node Group" (click)="updatePartition(partition)"></span> -->
                    <!-- <span class="bi bi-trash text-danger" title="Delete Node Group" (click)="deletePartition(partition)"></span> -->
                  </td>
                </tr>
              </tbody>
            </table>
  
            <p id="emptyError" *ngIf="partitionsAvailable == false">
              No Node Groups are available for selected deployment
            </p>
          </div>
        </div>
      </div>
    </div>
    
    <ngx-spinner bdColor="rgba(0,0,0,0)"
                 size="default"
                 color="var(--s-primary-color)"
                 type="ball-spin"
                 [fullScreen]="false"><p class="pleaseWait">Please wait ...</p></ngx-spinner>
  </div>
</div>
<ng-template #htmlContentTooltip>
  <div *ngIf="tooltipHtml != ''" [innerHTML]="tooltipHtml | safeHtml"></div>
</ng-template>

